import React, { useCallback, useLayoutEffect, useState } from 'react';
import { gql, useSuspenseFragment } from '@apollo/client';
import { SuppliersAdFragment } from '../../../codegen/graphql';
import { toast } from 'react-toastify';
import Button from '../common/Button';
import { SupplierCard, SupplierCard_SupplierProduct } from './SupplierCard/SupplierCard';
import { AddSupplierProductModal } from './AddSupplierProductModal';
import { useScreenContext } from '../Screen';

export const SUPPLIERS_AD_FRAGMENT = gql`
  fragment SuppliersAd on Ad {
    id
    supplierProducts {
      ...SupplierCard_SupplierProduct
    }
  }
  ${SupplierCard_SupplierProduct}
`;


export function SuppliersSection({
  adData,
  onUpdate,
}: {
  adData: SuppliersAdFragment;
  onUpdate: any;
}) {
  const screenContext = useScreenContext();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const handleAddSupplier = useCallback(() => {
    setIsAddModalOpen(true);
  }, []);

  const handleSupplierProductCreated = (supplierProduct: any) => {
    toast.success('Produit fournisseur créé avec succès');
    setIsAddModalOpen(false);
  };

  useLayoutEffect(() => {
    screenContext.nav.setActions([
      {
        label: 'Ajouter un fournisseur',
        onClick: handleAddSupplier,
      },
    ]);
  }, [handleAddSupplier]);

  return (<>
    {adData.supplierProducts.length > 0 ? (
      adData.supplierProducts.map((supplierProduct) => (
        <SupplierCard
          key={supplierProduct.id}
          adId={adData.id}
          supplierProduct={supplierProduct}
          updateAd={onUpdate}
          selectable={false}
        />
      ))
    ) : (
      <div className="bg-white shadow-sm rounded-lg p-6 text-center">
        <p className="text-gray-500">Aucun fournisseur associé à cette annonce</p>
      </div>
    )}

    {/* Add Supplier Product Modal */}
    {isAddModalOpen && (
      <AddSupplierProductModal
        onClose={() => setIsAddModalOpen(false)}
        onSuccess={handleSupplierProductCreated}
        adId={adData.id}
      />
    )}
  </>
  );
} 